(function() {
    "use strict";
    /**
     * Easy selector helper function
     */ const select = (el, all = false)=>{
        el = el.trim();
        if (all) return [
            ...document.querySelectorAll(el)
        ];
        else return document.querySelector(el);
    };
    /**
     * Easy event listener function
     */ const on = (type, el, listener, all = false)=>{
        let selectEl = select(el, all);
        if (selectEl) {
            if (all) selectEl.forEach((e)=>e.addEventListener(type, listener));
            else selectEl.addEventListener(type, listener);
        }
    };
    /**
     * Easy on scroll event listener 
     */ const onscroll = (el, listener)=>{
        el.addEventListener('scroll', listener);
    };
    /**
     * Navbar links active state on scroll
     */ let navbarlinks = select('#navbar .scrollto', true);
    const navbarlinksActive = ()=>{
        let position = window.scrollY + 200;
        navbarlinks.forEach((navbarlink)=>{
            if (!navbarlink.hash) return;
            let section = select(navbarlink.hash);
            if (!section) return;
            if (position >= section.offsetTop && position <= section.offsetTop + section.offsetHeight) navbarlink.classList.add('active');
            else navbarlink.classList.remove('active');
        });
    };
    window.addEventListener('load', navbarlinksActive);
    onscroll(document, navbarlinksActive);
    /**
     * Scrolls to an element with header offset
     */ const scrollto = (el)=>{
        let header = select('#header');
        let offset = header.offsetHeight;
        if (!header.classList.contains('header-scrolled')) offset -= 16;
        let elementPos = select(el).offsetTop;
        window.scrollTo({
            top: elementPos - offset,
            behavior: 'smooth'
        });
    };
    /**
     * Header fixed top on scroll
     */ let selectHeader = select('#header');
    if (selectHeader) {
        let headerOffset = selectHeader.offsetTop;
        let nextElement = selectHeader.nextElementSibling;
        const headerFixed = ()=>{
            if (headerOffset - window.scrollY <= 0) {
                selectHeader.classList.add('fixed-top');
                nextElement.classList.add('scrolled-offset');
            } else {
                selectHeader.classList.remove('fixed-top');
                nextElement.classList.remove('scrolled-offset');
            }
        };
        window.addEventListener('load', headerFixed);
        onscroll(document, headerFixed);
    }
    /**
     * Back to top button
     */ let backtotop = select('.back-to-top');
    if (backtotop) {
        const toggleBacktotop = ()=>{
            if (window.scrollY > 100) backtotop.classList.add('active');
            else backtotop.classList.remove('active');
        };
        window.addEventListener('load', toggleBacktotop);
        onscroll(document, toggleBacktotop);
    }
    /**
     * Mobile nav toggle
     */ on('click', '.mobile-nav-toggle', function(e) {
        select('#navbar').classList.toggle('navbar-mobile');
        this.classList.toggle('bi-list');
        this.classList.toggle('bi-x');
    });
    /**
     * Mobile nav dropdowns activate
     */ on('click', '.navbar .dropdown > a', function(e) {
        if (select('#navbar').classList.contains('navbar-mobile')) {
            e.preventDefault();
            this.nextElementSibling.classList.toggle('dropdown-active');
        }
    }, true);
    /**
     * Scrool with ofset on links with a class name .scrollto
     */ on('click', '.scrollto', function(e) {
        if (select(this.hash)) {
            e.preventDefault();
            let navbar = select('#navbar');
            if (navbar.classList.contains('navbar-mobile')) {
                navbar.classList.remove('navbar-mobile');
                let navbarToggle = select('.mobile-nav-toggle');
                navbarToggle.classList.toggle('bi-list');
                navbarToggle.classList.toggle('bi-x');
            }
            scrollto(this.hash);
        }
    }, true);
    /**
     * Scroll with ofset on page load with hash links in the url
     */ window.addEventListener('load', ()=>{
        if (window.location.hash) {
            if (select(window.location.hash)) scrollto(window.location.hash);
        }
    });
    /**
     * Animation on scroll
     */ window.addEventListener('load', ()=>{
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: true,
            mirror: false
        });
    });
    // Typewriter effect
    var typewriterElement = select('#typewriter');
    if (typewriterElement) {
        var typewriter = new Typewriter(typewriterElement, {
            loop: true,
            delay: 75
        });
        typewriter.pauseFor(750).typeString('Seasoned I.T. Team Leader empowering success through collaboration and innovation.').pauseFor(1000).deleteAll().typeString('Full Stack Developer with 20 years experience.').pauseFor(1000).deleteAll().typeString('Dedicated Father, Husband and all-round nice guy!').pauseFor(1000).start();
    }
})();

//# sourceMappingURL=repo.4c938990.js.map
